var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors)?_c('div',{staticClass:"border-danger alert d-flex",attrs:{"role":"alert"}},[_c('p',{staticClass:"text-danger mb-0 my-auto"},[_vm._v(_vm._s(_vm.errors.message))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }